
export interface WorkDaysCollection {
    dia: number;
    nombreDia?: string;
    horas: number[] | [] | null;
}

export interface WorkDaysCollectionPaginatedRes {
    count: number;
    next: null;
    previous: null;
    numero_paginas: number;
    data: WorkDaysCollection[];
}

export interface diasPermitidosInterface {
    dia: number;
    horas: number[]|null|[];
}


export const DAYS_WEEK_COLLECTION : WorkDaysCollectionPaginatedRes  = {
    count: 1,
    next: null,
    previous: null,
    numero_paginas: 1,
    data: [
        {
            dia:1,
            nombreDia:"Lunes",
            horas:null,
        },
        {
            dia:2,
            nombreDia:"Martes",
            horas:null,
        },
        {
            dia:3,
            nombreDia:"Miércoles",
            horas:null,
        },
        {
            dia:4,
            nombreDia:"Jueves",
            horas:null,
        },
        {
            dia:5,
            nombreDia:"Viernes",
            horas:null,
        },
        {
            dia:6,
            nombreDia:"Sábado",
            horas:null,
        },
        {
            dia:7,
            nombreDia:"Domingo",
            horas:null,
        },
    ],
}

export const DAYS_WEEK_COLLECTION_2 : diasPermitidosInterface[] =  [
    {
        dia:1,
        horas:null,
    },
    {
        dia:2,
        horas:null,
    },
    {
        dia:3,
        horas:null,
    },
    {
        dia:4,
        horas:null,
    },
    {
        dia:5,
        horas:null,
    },
    {
        dia:6,
        horas:null,
    },
    {
        dia:7,
        horas:null,
    },
]
